import {Inject, Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {LOGIN_URL} from 'app/common';
import {AuthUserService} from "./auth-user.service";
import {EnumLoginStatus, IUser} from "../interfaces";

@Injectable()
export class AuthGuard  {

    private readonly user: BehaviorSubject<IUser | null>;

    constructor(private authUserService: AuthUserService, private router: Router, @Inject(LOGIN_URL) private loginUrl: string) {
        this.user = this.authUserService.user$;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.user.value || this.user.value.loginStatus === EnumLoginStatus.LOGIN_FAILED) {
            this.authUserService.redirectUrl = state.url;
            this.router.navigateByUrl(this.loginUrl);
            return false;
        }
        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
